export default __webpack_public_path__ + "static/media/lower.123dddcb.png";